import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";

import Dialogs from "pages/Common/Dialogs";
const SelfieUpdate = (props: any) => {
  const [openDoneSelfie, setOpenDoneSelfie] = useState(false);
  const [openCancelSelfie, setOpenCancelSelfie] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const [users_detail, setClientDetails] = useState<any>({});

  useEffect(() => {
    // @ts-ignore
    const users_detail = JSON.parse(localStorage.getItem("users_detail"));
    // @ts-ignore
    const data = JSON.parse(localStorage.getItem("Data"));
    if (users_detail) {
      setClientDetails(users_detail);
    }
  }, []);

  const url = new URL(window.location.href);

  // get address from digio
  const data = {
    logo: "https://mtsinglepointfe-dev.mastertrust.co.in/static/media/logo.bacab52f1fd8ee8263a49a24482eebec.svg",
    token_id: url.searchParams.get("access_token_id"),
    requestId: url.searchParams.get("document_id"),
    identifier: url.searchParams.get("customer_identifier"),
  };
  useEffect(() => {
    initDigio(data);
  }, []);
  // @ts-ignore
  function initDigio({ logo, requestId, identifier, token_id }: any) {
    const digoOptions = {
      logo,
      is_redirection_approach: false,
      is_iframe: true,
      environment: process.env.REACT_APP_DIGIO_KEY,
    };

    // @ts-ignore
    digoOptions.callback = async (_digio: any) => {
      if (_digio.error_code === "CANCELLED") {
        setOpenCancelSelfie(true);
        return;
      }
      if (_digio.error_code !== undefined) {
        throw new Error(_digio.message);
      }
      if (_digio.message === "KYC process completed") {
        setOpenDoneSelfie(true);
      }
    };
    // @ts-ignore
    const digioInstance = new window.Digio(digoOptions);
    digioInstance.init();
    digioInstance.submit(requestId, identifier, token_id);
  }

  return (
    <>
      <Grid container className="form-container selfie"></Grid>
      <Dialogs
        openDoneSelfie={openDoneSelfie}
        openCancelSelfie={openCancelSelfie}
      />
    </>
  );
};

export default SelfieUpdate;
